import { inject, useId } from 'vue';
import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms/client';

export const isRequiredField = (field: FrontendFieldDefinition): boolean =>
    Boolean(field.validators?.some(({ kind }) => kind === 'form_validator_required' || kind === 'required'));

export const useFormFieldId = (): string => {
    const formId = inject<string>('formControlId', 'form');

    return `${formId}-${useId()}`;
};
